import { Component, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { ApiAuthService } from '../../../services/backend/public/api-auth/api-auth.service';

@Component({
  standalone: true,
  imports: [RouterLink],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  readonly auth = inject(ApiAuthService);
  private readonly query = inject(ActivatedRoute).snapshot.queryParamMap;
  readonly failed = this.query.has('auth_error');
  readonly unavailable = this.query.get('auth_error') === 'unavailable';
  readonly expired = this.query.has('session_expired');
  login(): void { this.auth.login(); }
}
